export default __webpack_public_path__ + "static/kindergarten-readiness1-a50ece4f7844e45c99047eb1bd3ad25d.jpg";